import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import { isSortKey, type SortKey } from '@/lib/sort'

// `sortby`, not `sort`: the sprint board already owns `?sort=` with a different
// vocabulary (Manual/Priority/Created). A distinct key keeps the two from
// aliasing each other across shared URLs / back-forward.
const PARAM = 'sortby'

/** Sort choice in the URL (?sortby=), so views stay sharable and the back button
 *  works. `order` is the default and is represented by the param's absence. */
export function useSortPreference(): [SortKey, (key: SortKey) => void] {
  const [params, setParams] = useSearchParams()
  const raw = params.get(PARAM)
  const key: SortKey = isSortKey(raw) ? raw : 'order'

  const set = useCallback(
    (next: SortKey) => {
      setParams(
        (prev) => {
          const p = new URLSearchParams(prev)
          if (next === 'order') p.delete(PARAM)
          else p.set(PARAM, next)
          return p
        },
        { replace: true },
      )
    },
    [setParams],
  )

  return [key, set]
}
